var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHostingServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E84F4F"
    },
    cx: 255.997,
    cy: 255.997,
    r: 255.997
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C94545"
    },
    d: "M511.527,239.605L396.768,124.847L157.163,137.3l-38.936,38.936l36.729,36.729l-36.572,36.571 l40.67,40.67l-43.35,30.109l46.345,46.029l-29.793,12.137L265.773,512C402.601,506.798,512,394.247,512,256.158 c0-5.517-0.158-10.877-0.473-16.394V239.605z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 250.014,
    y: 131.781,
    style: {
      fill: "#C5C6C6"
    },
    width: 12.137,
    height: 247.492
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.261,
    y: 366.195,
    style: {
      fill: "#C5C6C6"
    },
    width: 247.592,
    height: 12.145
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00CC96"
    },
    cx: 255.997,
    cy: 372.339,
    r: 19.547
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#12B589"
    },
    d: "M255.999,352.631c10.877,0,19.547,8.827,19.547,19.547s-8.67,19.389-19.389,19.547h-0.315v-39.251 L255.999,352.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD630"
    },
    d: "M124.69,120.118H387.31c6.529,0,11.822,5.293,11.822,11.822v34.364 c0,6.529-5.293,11.822-11.822,11.822H124.69c-6.529,0-11.822-5.293-11.822-11.822v-34.363 C112.867,125.411,118.16,120.118,124.69,120.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7A20B"
    },
    d: "M397.557,172.453c-2.049,3.468-5.833,5.833-10.246,5.833H124.69c-4.257,0-8.197-2.364-10.246-5.833 H397.4H397.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F7F8"
    },
    d: "M231.408,131.783h64.474c2.35,0,4.257,1.905,4.257,4.257v8.827c0,2.35-1.905,4.257-4.257,4.257 h-64.473c-2.35,0-4.257-1.905-4.257-4.257v-8.827C227.153,133.689,229.058,131.783,231.408,131.783z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M124.216,128.158h14.187v9.301h-14.187V128.158z M186.798,159.212h14.187v9.301h-14.187V159.212z  M165.99,159.212h14.187v9.301H165.99V159.212z M145.182,159.212h14.187v9.301h-14.187V159.212z M124.375,159.212h14.187v9.301 h-14.187V159.212z M186.956,143.763h14.187v9.301h-14.187V143.763z M166.148,143.763h14.187v9.301h-14.187V143.763z  M145.339,143.763h14.187v9.301h-14.187V143.763z M124.532,143.763h14.187v9.301h-14.187 C124.532,153.064,124.532,143.763,124.532,143.763z M187.113,128.315H201.3v9.301h-14.187V128.315z M166.305,128.315h14.187v9.301 h-14.187V128.315z M145.498,128.315h14.187v9.301h-14.187V128.315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M324.572,128.158h10.877v40.04h-10.877V128.158z M377.064,128.158h10.877v40.04h-10.877V128.158z  M359.566,128.158h10.877v40.04h-10.877V128.158z M342.068,128.158h10.877v40.04h-10.877V128.158z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD630"
    },
    d: "M124.69,193.261H387.31c6.529,0,11.822,5.293,11.822,11.822v34.364 c0,6.529-5.293,11.822-11.822,11.822H124.69c-6.529,0-11.822-5.293-11.822-11.822v-34.364 C112.867,198.554,118.16,193.261,124.69,193.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7A20B"
    },
    d: "M397.557,245.596c-2.049,3.468-5.833,5.833-10.246,5.833H124.69c-4.257,0-8.197-2.364-10.246-5.833 H397.4H397.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F7F8"
    },
    d: "M231.408,204.926h64.474c2.35,0,4.257,1.905,4.257,4.257v8.827c0,2.35-1.905,4.257-4.257,4.257 h-64.473c-2.35,0-4.257-1.905-4.257-4.257v-8.827C227.153,206.831,229.058,204.926,231.408,204.926z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M124.216,201.301h14.187v9.301h-14.187V201.301z M186.798,232.355h14.187v9.301h-14.187V232.355z  M165.99,232.355h14.187v9.301H165.99V232.355z M145.182,232.355h14.187v9.301h-14.187V232.355z M124.375,232.355h14.187v9.301 h-14.187V232.355z M186.956,216.906h14.187v9.301h-14.187V216.906z M166.148,216.906h14.187v9.301h-14.187V216.906z  M145.339,216.906h14.187v9.301h-14.187V216.906z M124.532,216.906h14.187v9.301h-14.187 C124.532,226.207,124.532,216.906,124.532,216.906z M187.113,201.458H201.3v9.301h-14.187V201.458z M166.305,201.458h14.187v9.301 h-14.187V201.458z M145.498,201.458h14.187v9.301h-14.187V201.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M324.572,201.301h10.877v40.04h-10.877V201.301z M377.064,201.301h10.877v40.04h-10.877V201.301z  M359.566,201.301h10.877v40.04h-10.877V201.301z M342.068,201.301h10.877v40.04h-10.877V201.301z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD630"
    },
    d: "M124.69,266.404H387.31c6.529,0,11.822,5.293,11.822,11.822v34.364 c0,6.529-5.293,11.822-11.822,11.822H124.69c-6.529,0-11.822-5.293-11.822-11.822v-34.364 C112.867,271.697,118.16,266.404,124.69,266.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7A20B"
    },
    d: "M397.557,318.739c-2.049,3.468-5.833,5.833-10.246,5.833H124.69c-4.257,0-8.197-2.364-10.246-5.833 H397.4H397.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F7F8"
    },
    d: "M231.408,278.069h64.474c2.35,0,4.257,1.905,4.257,4.257v8.827c0,2.35-1.905,4.257-4.257,4.257 h-64.473c-2.35,0-4.257-1.905-4.257-4.257v-8.827C227.153,279.974,229.058,278.069,231.408,278.069z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M124.216,274.286h14.187v9.301h-14.187V274.286z M186.798,305.34h14.187v9.301h-14.187V305.34z  M165.99,305.34h14.187v9.301H165.99V305.34z M145.182,305.34h14.187v9.301h-14.187V305.34z M124.375,305.34h14.187v9.301h-14.187 V305.34z M186.956,289.891h14.187v9.301h-14.187V289.891z M166.148,289.891h14.187v9.301h-14.187V289.891z M145.339,289.891h14.187 v9.301h-14.187V289.891z M124.532,289.891h14.187v9.301h-14.187C124.532,299.192,124.532,289.891,124.532,289.891z  M187.113,274.443H201.3v9.301h-14.187V274.443z M166.305,274.443h14.187v9.301h-14.187V274.443z M145.498,274.443h14.187v9.301 h-14.187V274.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M324.572,274.443h10.877v40.04h-10.877V274.443z M377.064,274.443h10.877v40.04h-10.877V274.443z  M359.566,274.443h10.877v40.04h-10.877V274.443z M342.068,274.443h10.877v40.04h-10.877V274.443z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostingServices);
export default __webpack_public_path__ + "static/media/hosting-services.eddc7adffa468d4fc961290d132a230b.svg";
export { ForwardRef as ReactComponent };